<template>
    <button @click.stop="download()" class="c-button" :class="selectedClasses" type="button">
        <font-awesome-icon :class="{'c-button__left-icon': variant !== 'iconOnly'}" icon="spinner-third" spin v-if="item.loadingDownload"></font-awesome-icon>
        <font-awesome-icon :class="{'c-button__left-icon': variant !== 'iconOnly'}" icon="download" v-else></font-awesome-icon>
        <span v-if="variant !== 'iconOnly'">Download</span>
    </button>
</template>

<script>
    export default {
        name: "download-button",
        props: {
            variant: {
                type: String,
                default: 'iconOnly',
                validator: (value) => {
                    // The value must match one of these strings
                    // Basic: Icon + Download Label
                    return ['iconOnly', 'basic', 'itemTileButton'].indexOf(value) !== -1;
                }
            },
            item: {
                type: Object,
                required: true
            }
        },
        computed: {
            selectedClasses() {
              return {
                  'c-button--for-item-tile': this.variant === 'itemTileButton'
              }
            },
            downloadModal() {
                return this.$store.state.downloadModal;
            }
        },
        methods: {
            download() {
                this.item.loadingDownload = true;

                this.$http.get(`/freedownloads/${this.item.getType()}/${this.item.id}`)
                    .then((response) => {
                        this.$store.commit("downloadable", {
                            downloadable: {
                                music: this.item,
                                exchange: response.data
                            }
                        });

                        this.downloadModal.modal('show');

                        this.item.loadingDownload = false;
                    })
                    .catch((error) => {
                        this.item.loadingDownload = false;
                    });
            },
        }
    }
</script>

<style lang="scss" scoped>
</style>